import React, { Component } from 'react';
import '../../css/modal.scss';
import { comma } from '../../lib/util/numberUtil';
import { Modal, Button } from 'antd';
import PayChangeDialog from '../../components/modal/PayChangeDialog';
import {
  getOrderPaymentListAsync,
  removeOrderPaymentAsync,
  removeAllOrderPaymentAsync,
} from '../../api/api';
import _ from 'lodash';
import image from '../../res/image'
import {modalStyle, modalErrorStyle} from "../../lib/util/codeUtil";

class PaymentChangeModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      selectedRow: null,
      payChangeModalOpen: false,
    };
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.isOpen !== this.props.isOpen) {
      this.getListAsync();
    }
  }

  removeAll = () => {
    if (this.state.list.length === 0) {
      return;
    }

    const self = this;
    Modal.confirm({
      ...modalStyle,
      content:
        '결제변경 목록을 전부 삭제하시겠습니까? 한번 삭제하는 경우 다시 불러올 수 없습니다.',
      okText: '확인',
      cancelText: '취소',
      onOk() {
        removeAllOrderPaymentAsync(self.state.list).then((success, fail) => {
          if (fail > 0) {
            Modal.error({
              title: '결제변경 삭제 오류',
              content: <div>오류가 발생하였습니다. 다시 시도해 주십시오.</div>,
              ...modalErrorStyle,
            });
          } else {
            self.props.renew(0);
            self.setState({ list: [] });
          }
        });
      },
      onCancel() {},
    });
  };
  remove = (idx) => {
    const self = this;
    Modal.confirm({
      ...modalStyle,
      content: '결제변경 건을 삭제하시겠습니까?',
      okText: '확인',
      cancelText: '취소',
      onOk() {
        removeOrderPaymentAsync(idx).then((result) => {
          if (result === 'SUCCESS') {
            const list = self.state.list.filter((x) => x.idx !== idx);
            self.setState({
              list,
            });
            self.props.renew(list.length);
          } else {
            Modal.error({
              title: '결제변경 삭제 오류',
              content: <div>오류가 발생하였습니다. 다시 시도해 주십시오.</div>,
              ...modalErrorStyle,
            });
          }
        });
      },
      onCancel() {},
    });
  };

  getListAsync = async () => {
    this.setState({ list: [] });

    const list = await getOrderPaymentListAsync();
    if (list === null) {
      return;
    }

    this.setState({ list });
  };

  openPayChangeDialog = (row) => {
    this.setState({
      selectedRow: row,
      payChangeDialogOpen: true,
    });
  };
  closePayChangeDialog = () => {
    this.setState({
      selectedRow: null,
      payChangeDialogOpen: false,
    });
  };

  render() {
    const { isOpen, close } = this.props;
    return (
      <React.Fragment>
        {isOpen ? (
          <React.Fragment>
            <div className="Modal-overlay" onClick={close} />
            <div className="Modal-wide">
              <div className="pw-title">결제변경 목록</div>
              <div className="pw-image" onClick={close}>
                <img style={{ display: 'inline' }} src={image.closeIcon} alt="" />
              </div>

              <PayChangeDialog
                data={this.state.selectedRow}
                isOpen={this.state.payChangeDialogOpen}
                close={this.closePayChangeDialog}
              />

              <div className="paymentchange-content">
                <div className="paymentchange-element-all">
                  <div className="paymentchange-element-block">
                    <div className="paymentchange-element-block-menu">
                      <div className="paymentchange-element-block-menu-text paychange1">
                        주문번호
                      </div>
                      <div className="paymentchange-element-block-menu-text2">
                        고객정보
                      </div>
                      <div className="paymentchange-element-block-menu-text">
                        상품가액
                      </div>
                      <div className="paymentchange-element-block-menu-text">
                        결제내역
                      </div>
                      <div className="paymentchange-element-block-menu-text">
                        삭제
                      </div>
                    </div>
                  </div>
                  <div className="paymentchange-element-block-field-wrapper">
                    {(!this.state.list || this.state.list.length) === 0 && (
                      <div style={{ textAlign: 'center', padding: '50px' }}>
                        내역이 없습니다.
                      </div>
                    )}
                    {this.state.list.map((row, index) => {
                      return (
                        <div
                          key={index}
                          className="paymentchange-element-block-field">
                          <div className="paymentchange-element-block-field-text1 paychange1">
                            {row.idx}
                          </div>
                          <div className="paymentchange-element-block-field-text2">
                            {row.destAddr1}
                            {row.destAddr2}
                            <div className="paymentchange-element-block-field-text2-sub">
                              {row.custPhone}
                            </div>
                          </div>
                          <div className="paymentchange-element-block-field-text1">
                            {comma(row.orderPrice)}원
                          </div>

                          <div className="paymentchange-element-block-field-text1">
                            <Button
                              className="del-btn mobileoff"
                              onClick={() => {
                                this.openPayChangeDialog(row);
                              }}>
                              상세
                            </Button>
                            <Button
                              className="del-btn mobile"
                              onClick={() => {
                                this.openPayChangeDialog(row);
                              }}>
                              상세
                            </Button>
                          </div>
                          <div className="paymentchange-element-block-field-text1">
                            <div
                              className="paymentchange-element-block-field-btn"
                              onClick={() => this.remove(row.idx)}>
                              삭제
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
                <div className="paymentchange-btn-wrapper">
                  <div
                    className="paymentchange-btn-delete"
                    onClick={() => {
                      this.removeAll();
                    }}>
                    전체삭제
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        ) : null}
      </React.Fragment>
    );
  }
}

export default PaymentChangeModal;
